import type { FC } from 'react'
import { useState } from 'react'

import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer'
import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import coverPng2x from './assets/Cover@2x.png'
import coverWebp from './assets/Cover.webp'
import coverWebp2x from './assets/Cover@2x.webp'

const HEADING = `Orchestrate intelligent engagement`
const DESCRIPTION = `Meet the first customer journey builder for the digital-first era, powered by Twilio Segment.`
const link = {
  href: `/product/twilio-engage/journeys/`,
  text: `Learn more`,
}
const VIDEO_URL = `https://vimeo.com/559103187?embedded=true&source=vimeo_logo&owner=50788297`

const CoverImage = () => {
  return (
    <VideoPlayer.Cover>
      <picture>
        <source type="image/webp" srcSet={`${coverWebp}, ${coverWebp2x} 2x`} />
        <Image width={1280} height={752} src={coverPng2x} alt="" />
      </picture>
    </VideoPlayer.Cover>
  )
}

const OrchestrateIntelligentEngagement: FC = () => {
  const [playing, setPlaying] = useState(false)
  const play = () => setPlaying(true)
  const stop = () => setPlaying(false)

  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2" variant="h2">
            {HEADING}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {DESCRIPTION}
          </CopyText.Description>
          <CopyText.Link href={link.href}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <VideoPlayerBase url={VIDEO_URL} playing={playing} onPause={stop} onPlay={play}>
          {!playing && (
            <>
              <VideoPlayer.BigPlayButton ariaLabel="Play Button" onClick={play} />
              <CoverImage key="cover" />
            </>
          )}
        </VideoPlayerBase>
      </Section.Contents>
    </SectionBase>
  )
}

export default OrchestrateIntelligentEngagement
